module.exports = __webpack_public_path__ + "img/page11_text.6bfb0a1d.png";